import { useMemo } from 'react';
import { useGetPermission } from './business/useNewPermisson';
import { useOrgConfigStateValue } from './business/useOrgConfig';

export const useProductKnowledgePermission = () => {
  const { whiteListConfig: { COMMODITY_KONWLEDGE } = {} } = useOrgConfigStateValue();
  const getPermission = useGetPermission();

  return useMemo(() => {
    return COMMODITY_KONWLEDGE && getPermission('商品知识');
  }, [COMMODITY_KONWLEDGE, getPermission]);
};
